module.exports = __webpack_public_path__ + "static/logo-265bdec941628e555c52701092325db0.jpeg";